






















import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class DetailContentJifentiao extends Vue {
  @Prop()
  private content: any;

  private value: any = 0;
  /**
   * @description 获取store中的可编辑状态
   */
  private get ifCompose() {
    return this.$store.state.ifCompose;
  }
  private formatTooltio(val) {
    return val + "分";
  }
  private changeValue(val) {
    this.content.value = val;
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.value = this.content.value || 0;
  }
}
